import { Component } from 'react'
import {
    Autocomplete, Box, Button, Drawer, Stack, TextField, Tooltip,
    Typography, FormControlLabel, Checkbox
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { withTranslation } from 'react-i18next';
import '../reports.css';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { CommonGridToolBarWithFilterText, CommonTimeRangePicker } from
    "../../../../Components/Common Components/CommonComponents";
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { AmountFormat, formatDate, timeOnlyConvert } from "../../../../Components/CommonFunctions/CommonFunctions";
import { DateTime } from 'luxon';
import { CurrencySymbol } from '../../../../Utility/Constants';
import { Colors } from '../../../../Styles/Colors';

class OPServiceShare extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            doctorName: [],
            serviceName: [],
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            serviceShareData: [],
            serviceTotalAmount: "",
            serviceDoctorName: [],
            hospitalShare: '',
            doctorShare: '',
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilterDatas: {
                "startTime": null,
                "endTime": null,
                "onError": false,
            },
            timeError: false,
            serviceHeads: [], // List of Service Heads
            inHouseChecked: true,
            visitingChecked: true,
            doctorType: ["In House", "Visiting"],
        }
    }

    componentDidMount() {
        this.getOpServiceShareReport()
        this.getServiceFilterDoctorList()
        this.getModuleList()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        }, () => {
            this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas: this.state.FilterDatas
            })
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    getServiceFilterDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            serviceDoctorName: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getOpServiceShareReport = () => {
        try {
            this.LoaderFunction(true)
            let doctorId = []; let serviceName = [];
            this.state.doctorName.forEach(element => doctorId.push(element.doctor_id))
            this.state.serviceName.forEach(element => serviceName.push(element.head_name))
            var { FilterDatas } = this.state
            let start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : ''
            let end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : ''
            let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            RestAPIService.getAll(`${Serviceurls.NEW_DOCTOR_SHARE_REPORT}?from_date=${this.state.fromDate}&service_type=${serviceName ? encodeURIComponent(serviceName) : ""}&doctor_id=${doctorId}&to_date=${this.state.toDate}&module_type=OP&start_time=${setStartTime}&end_time=${setEndTime}&doctor_type=${this.state.doctorType}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            serviceShareData: response.data.data,
                            hospitalShare: response.data.hospital_share_amount,
                            doctorShare: response.data.doctor_share_amount,
                            FilteredFromDate: this.state.fromDate,
                            FilteredToDate: this.state.toDate,
                        }, () => { this.LoaderFunction(false) })
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })

        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }

    getOpServiceShareReportPrint = () => {
        try {
            let doctorId = []; let serviceName = [];
            this.state.doctorName.forEach(element => doctorId.push(element.doctor_id))
            this.state.serviceName.forEach(element => serviceName.push(element.head_name))
            var { FilterDatas } = this.state
            let start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : ''
            let end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : ''
            let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            RestAPIService.getAll(`${Serviceurls.NEW_DOCTOR_SHARE_REPORT}?from_date=${this.state.fromDate}&servie_type=${serviceName ? encodeURIComponent(serviceName) : ''}&doctor_id=${doctorId}&to_date=${this.state.toDate}&export_type=pdf&module_type=OP&start_time=${setStartTime}&end_time=${setEndTime}&doctor_type=${this.state.doctorType}`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    this.errorMessage(error.response?.data?.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }

    selectedTime = (start, end, error) => {
        this.state.FilterDatas.startTime = start
        this.state.FilterDatas.endTime = end
        this.setState({ FilterDatas: this.state.FilterDatas, timeError: error })
    }


    getModuleList = () => {
        try {
            let serviceTypes = [];
            RestAPIService.getAll(Serviceurls.NEW_SERVICE_LIST_REPORT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const ModuleData = response.data.data || {};
                        let uniqueHeads = new Set(); // Store unique head names
                        Object.keys(ModuleData).forEach(moduleType => {
                            if (moduleType === "IP") return; // Exclude IP
                            ModuleData[moduleType].forEach(({ id, head_name, service_details }) => {
                                if (!uniqueHeads.has(head_name)) {
                                    uniqueHeads.add(head_name);
                                    serviceTypes.push({ head_name });
                                }
                            });
                        });
                        this.setState({ serviceHeads: serviceTypes });
                    }
                })
                .catch((error) => {
                    const errorMessage = error?.response?.data?.message || error?.message || "An unknown error occurred";
                    this.errorMessage(errorMessage);
                });
        } catch (error) {
            this.errorMessage(error.message);
        }
    };

    handleCheckBox = (e, key) => {
        const isChecked = e.target.checked;

        // Temporarily update the state to simulate the new checkbox state
        const updatedState = {
            ...this.state,
            [key]: isChecked,
        };

        // Prevent both from being unchecked
        if (!updatedState.inHouseChecked && !updatedState.visitingChecked) {
            // Don't update if both would be false
            return;
        }

        // Create the doctorType array based on new state
        const doctorType = [];
        if (updatedState.inHouseChecked) {
            doctorType.push('In House');
        }
        if (updatedState.visitingChecked) {
            doctorType.push('Visiting');
        }

        // Update the state
        this.setState({
            ...updatedState,
            doctorType,
        });
    };

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box sx={{ width: '22vw' }}>
                        <CommonTimeRangePicker
                            startTime={this.state.FilterDatas?.startTime}
                            endTime={this.state.FilterDatas?.endTime}
                            selectedTime={this.selectedTime.bind(this)}
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            onError={this.state.FilterDatas.onError}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={this.state.serviceDoctorName?.map((item) => item)}
                            getOptionLabel={(option) => (option?.doctor_name)}
                            value={this.state.doctorName}
                            onChange={(event, newValue) => {
                                this.setState({ doctorName: newValue })
                            }}
                            renderOption={(props, option) => (
                                <li {...props} key={option?.doctor_id}>
                                    {option?.doctor_name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('selectDoctor')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={this.state.serviceHeads}
                            getOptionLabel={(option) => (option.head_name)}
                            value={this.state.serviceName}
                            onChange={(event, newValue) => {
                                this.setState({ serviceName: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("Select Service Head")}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Typography fontWeight={500} fontSize={"1vw"}>{t("Doctor Type")}</Typography>
                        <Box display={'flex'} flexDirection={'row'} alignItems={'flex-start'}>
                            <FormControlLabel control={<Checkbox emed_tid={"inHouseChecked_TestID"} size="small" checked={this.state.inHouseChecked} onChange={(e) => { this.handleCheckBox(e, "inHouseChecked") }} />} label={t("In House")} />
                            <FormControlLabel control={<Checkbox emed_tid={"visitingChecked_TestID"} size="small" checked={this.state.visitingChecked} onChange={(e) => { this.handleCheckBox(e, "visitingChecked") }} />} label={t("Visiting")} />
                        </Box>
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                doctorName: [],
                                serviceName: [],
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                FilterDatas: {
                                    "startTime": null,
                                    "endTime": null,
                                    "onError": false
                                },
                                timeError: false,
                                inHouseChecked: true,
                                visitingChecked: true,
                                doctorType: ["In House", "Visiting"],
                            }, () => this.getOpServiceShareReport())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        disabled={(this.state.inHouseChecked === false && this.state.visitingChecked === false) || (this.state.FilterDatas.startTime ? (this.state.FilterDatas.startTime && this.state.FilterDatas.endTime && this.state.timeError != true) ? false : true : false)}
                        onClick={() => {
                            this.getOpServiceShareReport()
                            this.setState({ FilterOpen: false })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }
    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    gridToolBar = () => {
        let start_time = this.state.FilterDatas.startTime ? new Date(this.state.FilterDatas.startTime) : ''
        let end_time = this.state.FilterDatas.endTime ? new Date(this.state.FilterDatas.endTime) : ''
        let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.FilteredFromDate) },
            { label: "To Date", value: formatDate(this.state.FilteredToDate) },
        ]
        if (this.state.FilterDatas.startTime !== null && this.state.FilterDatas.endTime !== null) {
            TextArray.push(
                { label: "Start Time", value: timeOnlyConvert(setStartTime) },
                { label: "End Time", value: timeOnlyConvert(setEndTime) }
            )
        }
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }

    render() {
        this.state.serviceShareData.forEach((element, index) => element.sno = index + 1)
        const { t } = this.props
        const columns = [
            {
                field: "created_date", headerName: 'Date', flex: 0.143, align: 'center', headerAlign: 'center',
                renderCell: (params) => <Box>{params?.row?.created_date ? formatDate(params?.row?.created_date) : '-'}</Box>
            },
            {
                field: "doctor_name", headerName: t("DoctorName"), flex: 0.143,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.doctor_name?.length > 20 ?
                    <Tooltip placement='top' title={params?.row?.doctor_name} arrow><div>{params?.row?.doctor_name.slice(0, 20) + "..."}</div></Tooltip>
                    : params?.row?.doctor_name ? params?.row?.doctor_name : "-"}</Box>)
            },
            {
                field: "doctor_type", headerName: t("Doctor Type"), flex: 0.143,
                renderCell: ({ row }) => {
                    (<Box component={'div'}>{row?.doctor_type?.length > 20 ?
                        <Tooltip placement='top' title={row?.doctor_type} arrow><div>{row?.doctor_type.slice(0, 20) + "..."}</div></Tooltip>
                        : row?.doctor_type || "-"}</Box>)
                }
            },
            {
                field: "service_type", headerName: t("Service Head"), flex: 0.143,
                renderCell: (params) => (
                    <Box component={'div'}>
                        {params?.row?.service_type?.length > 20 ? <Tooltip placement='top' title={params?.row?.service_type} arrow><div>{params?.row?.service_type.slice(0, 20) + "..."}</div></Tooltip> : params?.row?.service_type ? params?.row?.service_type : "-"}
                        {params?.row?.service_name?.length > 20 ? <Tooltip placement='top' title={params?.row?.service_name} arrow>
                            <Typography fontSize={"0.8vw"} color={Colors?.grayShade}>{params?.row?.service_name.slice(0, 20) + "..."}</Typography>
                        </Tooltip>
                            : params?.row?.service_name ? <Typography fontSize={"0.8vw"} color={Colors?.grayShade}>{params?.row?.service_name}</Typography> : "-"}
                    </Box>
                ),
                valueGetter: (params) => {
                    const type = params.row?.service_type || "";
                    const name = params.row?.service_name || "";
                    return `${type} ${name}`;
                }
            },
            {
                field: "service_unit_count", headerName: t("Count"), flex: 0.143, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.service_unit_count?.length > 20 ?
                    <Tooltip placement='top' title={params?.row?.service_unit_count} arrow><div>{params?.row?.service_unit_count.slice(0, 20) + "..."}</div></Tooltip>
                    : params?.row?.service_unit_count ? params?.row?.service_unit_count : "-"}</Box>)
            },
            {
                field: "doctor_share_amount", headerName: t("DoctorShare"), flex: 0.143, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.doctor_share_amount ? AmountFormat(params?.row?.doctor_share_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: "hospital_share_amount", headerName: t("HospitalShare"), flex: 0.143, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.hospital_share_amount ? AmountFormat(params?.row?.hospital_share_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: "discount_amount", headerName: `${t("concession")}`, flex: 0.143, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.discount_amount ? AmountFormat(params?.row?.discount_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            }
        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {AmountsCard(t("DoctorShare"), this.state.doctorShare)}
                        {AmountsCard(t("HospitalShare"), this.state.hospitalShare)}
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div' display={'flex'} padding={'0.5vw'} width={'7vw'}>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.getOpServiceShareReportPrint() }}>
                                <img src={ImagePaths.LabPrintIcon.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.serviceShareData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        pageSizeOptions={[10, 20, 30]}
                        pagination
                        paginationMode="client"
                        paginationModel={{
                            page: this.state.page,
                            pageSize: this.state.pageSize
                        }}
                        onPaginationModelChange={(model) => {
                            this.setState({
                                page: model.page,
                                pageSize: model.pageSize
                            })
                        }}
                        headerHeight={40}
                        disableRowSelectionOnClick
                        loading={this.state.isLoader}
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}


export default withTranslation()(OPServiceShare)